import React, { createContext, useContext } from "react"
import { Outlet } from "react-router-dom"
import { SectionFeatures } from "../types/sectionFeatures"

type ContextState = {
  sectionFeatures?: SectionFeatures
}

export const SectionFeaturesContext = createContext<ContextState | undefined>(undefined)

export const SectionFeaturesProvider = ({
  sectionFeatures,
  children,
}: {
  sectionFeatures?: SectionFeatures
  children?: React.ReactNode
}) => {
  const value = {
    sectionFeatures,
  }

  return <SectionFeaturesContext.Provider value={value}>{children || <Outlet />}</SectionFeaturesContext.Provider>
}

/**
 * Hook to check if a section feature is enabled.
 * Only returns true if the feature is explicitly enabled.
 *
 * @param sectionName - The name of the section to check (e.g., "deployments", "assets")
 * @returns true if the section is explicitly enabled, false otherwise
 */
export function useIsSectionEnabled(sectionName: string): boolean {
  const context = useContext(SectionFeaturesContext)

  // Default to false (only show if explicitly enabled)
  if (!context?.sectionFeatures) {
    return false
  }

  const sectionFeature = context.sectionFeatures[sectionName]

  // If feature not found in list, default to false
  if (!sectionFeature) {
    return false
  }

  // Return enabled status
  return sectionFeature.enabled
}
